import * as React from 'react';
import type { SVGProps } from 'react';

const IconReply = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 13" {...props}>
    <path
      fill="currentColor"
      d="M9.63 4.592c2.966 0 5.37 2.687 5.37 6v2.393h-1.79v-2.393c0-2.209-1.603-4-3.58-4H5.383l-.013 4.433L0 5.525l5.37-5.5-.013 4.57 4.273-.003Z"
    />
  </svg>
);
export default IconReply;
